import { render, staticRenderFns } from "./IconStar.vue?vue&type=template&id=2c29e365&"
import script from "./IconStar.vue?vue&type=script&lang=js&"
export * from "./IconStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports